import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import Context from './SessionProvider';
import APP from '../../tools/AppRoutes';
import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';

const Session = ({ history }) => {    
    const { logout, user } = useContext(Context);

    const cerrarSesion = () => {
        logout();
        history.push(APP.INDEX);
    }

    if(user && user.Usuario !== "") {
        return(
            <div className="float-right fontExo" style={{fontSize: 12, alignItems: 'flex-start', display: 'flex', height: '31px', paddingTop: '5px'}}>
                <label style={{color:'white'}} >Bienvenido(a):</label>
                <label style={{color:'white'}} className="font-weight-bold">&nbsp;{user.Nombre}</label>
                <div style={{height: '31px'}}>
                    <Button style={{color:'white', padding: '0px'}} variant="text" endIcon={<LogoutIcon />} onClick={ cerrarSesion }></Button>
                </div>
                
            </div>
        )
    } else {
        return(
            <div></div>
        )
    }
}

export default withRouter(Session);